import { render, staticRenderFns } from "./FourOverTool.vue?vue&type=template&id=07819120&scoped=true"
import script from "./FourOverTool.vue?vue&type=script&lang=js"
export * from "./FourOverTool.vue?vue&type=script&lang=js"
import style0 from "./FourOverTool.vue?vue&type=style&index=0&id=07819120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07819120",
  null
  
)

export default component.exports